<p-table class="height100" #turboTable [value]="filteredRegistrations"
  styleClass="p-datatable-striped p-datatable-gridlines" [resizableColumns]="true" [scrollable]="true">
  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn pSortableColumn="startNumber" pFrozenColumn style="flex: 0 0 80px">
        #<i class="pi pi-pencil lightgray"></i>
      </th>
      <th pResizableColumn pSortableColumn="user.name" style="flex: 1 0 200px">
        {{ appSettings.translate[appSettings.selectedLang]["name"] }}
      </th>
      <th pResizableColumn pSortableColumn="user.city" style="flex: 0 0 200px">
        {{ appSettings.translate[appSettings.selectedLang]["city"] }}
      </th>
      <th pResizableColumn pSortableColumn="user.birthdate" style="flex: 0 0 100px">
        {{ appSettings.translate[appSettings.selectedLang]["birthdate"] }}
      </th>
      <th pResizableColumn pSortableColumn="user.phone" style="flex: 0 0 110px">
        {{ appSettings.translate[appSettings.selectedLang]["phone"] }}
      </th>
      <th pResizableColumn pSortableColumn="user.team" style="flex: 0 0 120px">
        {{ appSettings.translate[appSettings.selectedLang]["team"] }}
      </th>
      <th pResizableColumn pSortableColumn="info" style="flex: 1 0 100px">
        {{ race.infoFieldName }}<i class="pi pi-pencil lightgray"></i>
      </th>
      <th pResizableColumn pSortableColumn="registrationTime" style="flex: 0 0 150px"
        [ngClass]="{ wrap_words: filter === 'deleted_reg' }">
        {{ appSettings.translate[appSettings.selectedLang]["reg_time"] }}
        <ng-container *ngIf="filter === 'deleted_reg'">
          /
          {{
          appSettings.translate[appSettings.selectedLang]["del_time"]
          }}</ng-container>
      </th>
      <th pResizableColumn pSortableColumn="startFee" style="flex: 0 0 100px">
        {{ appSettings.translate[appSettings.selectedLang]["start_fee"] }}
        <i class="pi pi-pencil lightgray"></i>
      </th>
      <th pResizableColumn pSortableColumn="allDocumentsValid" style="flex: 0 0 80px">
        {{ appSettings.translate[appSettings.selectedLang]["docs"] }}
        <i class="pi pi-pencil lightgray"></i>
      </th>
      <th pResizableColumn pSortableColumn="gpsTracker" style="flex: 0 0 70px">
        {{ appSettings.translate[appSettings.selectedLang]["gps_tracker"] }}
      </th>
      <th pResizableColumn pSortableColumn="chronoTag" style="flex: 0 0 80px">
        {{ appSettings.translate[appSettings.selectedLang]["chrono_tag"]
        }}<i class="pi pi-pencil lightgray"></i>
      </th>
      <th pResizableColumn style="flex: 0 0 120px">
        {{ appSettings.translate[appSettings.selectedLang]["org_comment"]
        }}<i class="pi pi-pencil lightgray"></i>
      </th>
      <th style="flex: 0 0 40px">...</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td style="flex: 0 0 80px" class="right editable" pFrozenColumn pEditableColumn>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input class="right width100" pInputText type="number" [(ngModel)]="tempStartNumber"
              (focus)="setTmpStartNumber(rowData)" (blur)="onChangeStartNumber(rowData)"
              (keydown.enter)="onChangeStartNumber(rowData)" />
          </ng-template>
          <ng-template pTemplate="output">
            {{ rowData.startNumber }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="flex: 1 0 200px" class="editable" (click)="clickByTd('name', rowData)">
        {{ rowData.user.name }}
      </td>
      <td style="flex: 0 0 200px">{{ rowData.user.city }}</td>
      <td style="flex: 0 0 100px" class="right">
        {{ rowData.user.birthdate | date : "dd.MM.yyyy" }}
      </td>
      <td style="flex: 0 0 110px" class="right">{{ rowData.user.phone }}</td>
      <td style="flex: 0 0 120px" pEditableColumn class="editable">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input class="width100" pInputText type="text" [(ngModel)]="tempTeamInfo" (focus)="setTmpTeamInfo(rowData)"
              (blur)="onChangeTeamInfo(rowData)" (keydown.enter)="onChangeTeamInfo(rowData)" />
          </ng-template>
          <ng-template pTemplate="output">
            {{ rowData.user.team }}
          </ng-template>
        </p-cellEditor>


      </td>
      <td style="flex: 1 0 100px" pEditableColumn class="editable">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input class="width100" pInputText type="text" [(ngModel)]="tempRegInfo" (focus)="setTmpRegInfo(rowData)"
              (blur)="onChangeRegInfo(rowData)" (keydown.enter)="onChangeRegInfo(rowData)" />
          </ng-template>
          <ng-template pTemplate="output">
            {{ rowData.info }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="flex: 0 0 150px" class="right editable" [ngClass]="{ wrap_words: filter === 'deleted_reg' }"
        (click)="onTimeClick(rowData)">
        <span [innerHTML]="calculateLocalTime(rowData)"></span>
      </td>
      <td style="flex: 0 0 100px" class="editable right" pEditableColumn>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input class="width100" pInputText type="number" min="0" step="1" [(ngModel)]="tempFee"
              (focus)="setTmpFee(rowData)" (blur)="onChangeFee(rowData)" (keydown.enter)="onChangeFee(rowData)"
              (ngModelChange)="tempFee = sanitizePositiveInt($event).toString()" />
          </ng-template>
          <ng-template pTemplate="output">
            {{ rowData.startFee }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="flex: 0 0 80px" class="editable right" [ngClass]="{
          doc_confirmed: rowData.doc_confirmed,
          doc_invalid: rowData.doc_invalid,
          doc_new: rowData.doc_new
        }" (click)="clickByTd('allDocumentsValid', rowData)">
        {{ rowData.allDocumentsValid ? "V" : "" }}
      </td>
      <td style="flex: 0 0 70px" (click)="clickByTd('gpsTracker', rowData)">
        {{ rowData.gpsTracker }}
      </td>
      <td style="flex: 0 0 80px" class="right editable" pEditableColumn>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input class="right width100" pInputText type="number" [(ngModel)]="tempChronoTag"
              (focus)="setTmpChronoTag(rowData)" (blur)="onChangeChronoTag(rowData)"
              (keydown.enter)="onChangeChronoTag(rowData)" />
          </ng-template>
          <ng-template pTemplate="output">
            {{ rowData.chronoTag }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="flex: 0 0 120px" class="editable" pEditableColumn>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input class="width100" pInputText type="text" [(ngModel)]="tempOrgComment"
              (focus)="setTmpOrgComment(rowData)" (blur)="onChangeOrgComment(rowData)"
              (keydown.enter)="onChangeOrgComment(rowData)" />
          </ng-template>
          <ng-template pTemplate="output">
            {{ rowData.orgComment }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="flex: 0 0 40px">
        <a (click)="showMenu(rowData)" class="anchor"> ...</a>
      </td>
    </tr>

    <tr *ngIf="rowData.crew && rowData.crew.length > 0">
      <td class="crew-table-cell">
        <table class="sub-table-crew">
          <tbody>
            <tr *ngFor="let crewMember of rowData.crew">
              <td>{{ crewMember.name }}</td>
              <td>{{ crewMember.city }}</td>
              <td>{{ crewMember.birthdate | date : "dd.MM.yyyy" }}</td>
              <td>{{ crewMember.phone }}</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    <tr>
      <td style="flex: 0 0 80px">
        <strong>{{
          appSettings.translate[appSettings.selectedLang]["totals"]
          }}</strong>
      </td>
      <td style="flex: 1 0 300px" class="right">
        <strong>{{
          appSettings.translate[appSettings.selectedLang][
          "competitors_totals"
          ]
          }}
          {{ totals.competitors }}</strong>
      </td>
      <td style="flex: 0 0 200px"></td>
      <td style="flex: 0 0 100px"></td>
      <td style="flex: 0 0 110px"></td>
      <td style="flex: 0 0 150px"></td>
      <td style="flex: 1 0 150px"></td>
      <td style="flex: 0 0 150px"></td>
      <td style="flex: 0 0 100px" class="right">
        <strong>{{ totals.fee }}</strong>
      </td>
      <td style="flex: 0 0 80px"></td>
      <td style="flex: 0 0 70px" class="right">
        <strong>{{ totals.gpsTrackers }}</strong>
      </td>
      <td style="flex: 0 0 80px" class="right">
        <strong>{{ totals.chronoTags }}</strong>
      </td>
      <td style="flex: 0 0 40px"></td>
    </tr>
  </ng-template>
</p-table>

<!-- Диалог редактирования времени регистрации -->
<p-dialog
  [header]="appSettings.translate[appSettings.selectedLang]['reg_time']"
  [(visible)]="dialogRegistrationTimeVisible"
  [modal]="true"
  [style]="{ width: '450px' }"
  [draggable]="true">
  <div class="p-fluid">
    <input
      pInputText
      [(ngModel)]="dialogRegistrationTimeText"
      (ngModelChange)="onRegistrationTimeTextChange()"
      (keydown.enter)="onRegistrationTimeSelect()"
      placeholder="dd.MM.yyyy HH:mm:ss"
      style="margin-bottom: 10px" />
    <p-calendar
      [(ngModel)]="dialogRegistrationTimeValue"
      dateFormat="dd.mm.yy"
      [showTime]="true"
      [showSeconds]="true"
      [inline]="true"
      (onSelect)="onRegistrationTimeSelect()"
    ></p-calendar>
  </div>
  <p-footer>
    <p-button
      [label]="appSettings.translate[appSettings.selectedLang]['cancel']"
      (click)="dialogRegistrationTimeVisible = false"
      styleClass="ui-button-danger"></p-button>
    <p-button
      [label]="appSettings.translate[appSettings.selectedLang]['ok']"
      (click)="saveRegistrationTimeDialog()"></p-button>
  </p-footer>
</p-dialog>

<!-- Диалог проверки документов участника -->
<app-partipian-documents *ngIf="dialogConfirmed" [dialogData]="dialogData" [(dialogConfirmed)]="dialogConfirmed"
  (saveDocumentsEvent)="saveDocuments($event)"></app-partipian-documents>

<!-- Диалог добавления участника оргом -->
<div *ngIf="dialogRegForm">
  <div *ngIf="classData">
    <race-form [raceClasses]="raceClasses" [user]="selectedRegistration?.user" [selectedClass]="classData"
      [classUser]="selectedRegistration" [race]="race" mode="add_registration_by_org"
      [currentRaceClass]="classData.clUid" (closeDialog)="closeRegistrationDataDialog($event)"></race-form>
  </div>
</div>